// ============================================
// MyPage Store (Zustand)
// 마이페이지 상태 관리
// ============================================

import { createStore } from 'zustand/vanilla';

export const useMypageStore = createStore((set, get) => ({
  // ============================================
  // State
  // ============================================

  // Carbon History
  carbonHistoryData: [],
  currentHistoryFilter: 'all',

  // Avatar Cache
  cachedAvatarUrl: null,
  cachedAvatarPosition: 'center 20%',
  avatarLoaded: false,
  avatarImageData: null,
  avatarObjectPosition: 'center 20%',

  // ============================================
  // Actions - Carbon History
  // ============================================

  setCarbonHistoryData: (data) => set({ carbonHistoryData: data }),

  setCurrentHistoryFilter: (filter) => set({ currentHistoryFilter: filter }),

  // ============================================
  // Actions - Avatar
  // ============================================

  setAvatarImageData: (data) => set({ avatarImageData: data }),

  setAvatarObjectPosition: (position) => set({ avatarObjectPosition: position }),

  updateAvatarCache: (url, position) => set({
    cachedAvatarUrl: url,
    cachedAvatarPosition: position || 'center 20%',
    avatarLoaded: true
  }),

  setAvatarLoaded: (loaded) => set({ avatarLoaded: loaded }),

  setCachedAvatarUrl: (url) => set({ cachedAvatarUrl: url }),

  setCachedAvatarPosition: (position) => set({ cachedAvatarPosition: position }),

  // ============================================
  // Selectors
  // ============================================

  getAvatarState: () => {
    const state = get();
    return {
      cachedAvatarUrl: state.cachedAvatarUrl,
      cachedAvatarPosition: state.cachedAvatarPosition,
      avatarLoaded: state.avatarLoaded,
      avatarImageData: state.avatarImageData,
      avatarObjectPosition: state.avatarObjectPosition
    };
  },

  // ============================================
  // Reset
  // ============================================

  resetAvatar: () => set({
    cachedAvatarUrl: null,
    cachedAvatarPosition: 'center 20%',
    avatarLoaded: false,
    avatarImageData: null,
    avatarObjectPosition: 'center 20%'
  })
}));

export default useMypageStore;
